import React from 'react';

type Props = {
  amount: number;
  decimalPlaces?: number;
};

const Hours = ({ amount, decimalPlaces = 2 }: Props) => {
  return <span>{amount.toFixed(decimalPlaces)}</span>;
};

export default Hours;
